import { CSVLink } from "react-csv";
import { IconButton, ListItemIcon, Menu, Text, Icon } from "@techzyapp/ui-lib";

export interface TableExportEmailProps {
  fetch: () => Promise<void>;
  loading?: boolean;
}

export interface TableExportProps {
  data?: any;
  filename?: string;
  email?: TableExportEmailProps;
  currentPage?: boolean;
}

const TableExport = ({
  data = [],
  filename = "Untitled",
  email,
  currentPage = true,
}: TableExportProps) => {
  const handleSendOnEmail = () => {
    email?.fetch().catch();
  };

  return (
    <Menu
      size="sm"
      component={
        <IconButton
          iconName="DocumentDownload"
          variant="filled"
          loading={email?.loading}
          disabled={email?.loading}
        />
      }
      items={[
        {
          children: (
            <div onClick={handleSendOnEmail} style={{ display: "flex" }}>
              <ListItemIcon>
                <Icon name="Sms" color="primaryLight" />
              </ListItemIcon>
              <Text color="primaryLight">Send On Email</Text>
            </div>
          ),
          disabled: !email,
        },
        {
          children: (
            <CSVLink data={data} filename={filename} separator={";"}>
              <div style={{ display: "flex" }}>
                <ListItemIcon>
                  <Icon name="DocumentDownload" color="primaryLight" />
                </ListItemIcon>
                <Text color="primaryLight">
                  <span style={{ textDecoration: "none" }}>
                    Export This Page
                  </span>
                </Text>
              </div>
            </CSVLink>
          ),
          disabled: !currentPage,
        },
      ]}
    />
  );
};

export default TableExport;
